import { InfoPagina } from '@hm_app/@core/models/info';
import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class InfoPaginaService {

    // Observable sources
    private infoPagina = new BehaviorSubject<InfoPagina>(null);

    // Observable streams
    infoPaginaObservable = this.infoPagina.asObservable();

    // Service message commands
    passInfoPagina(infoPagina: InfoPagina) {
        this.infoPagina.next(infoPagina);
        // console.log(this.infoPagina)
    }
}
